import type { IEngagementStatsFacility } from '@pages/SiteEngagement/model/engagementStatsFacility';

interface ISeriesItem {
  y: number;
  name: string;
}

export const getSiteEngagementSeriesData = (data?: IEngagementStatsFacility) => {
  const age: ISeriesItem[] = [];
  const timeAwaiting: ISeriesItem[] = [];
  const siteResponse: ISeriesItem[] = [];
  const initialResponse: ISeriesItem[] = [];

  let min = Infinity;
  let max = -Infinity;

  if (!data)
    return {
      age,
      timeAwaiting,
      siteResponse,
      initialResponse,
      min,
      max,
    };

  data.facilities.forEach((item) => {
    age.push({ y: item.avg_age, name: item.facility_name });
    timeAwaiting.push({ y: item.avg_customer_response, name: item.facility_name });
    siteResponse.push({ y: item.avg_customer_response_average, name: item.facility_name });
    initialResponse.push({
      y: item.avg_days_after_first_customer_reaction,
      name: item.facility_name,
    });

    min = Math.min(
      min,
      item.avg_age,
      item.avg_customer_response,
      item.avg_customer_response_average,
      item.avg_days_after_first_customer_reaction,
    );
    max = Math.max(
      max,
      item.avg_age,
      item.avg_customer_response,
      item.avg_customer_response_average,
      item.avg_days_after_first_customer_reaction,
    );
  });

  return {
    age,
    timeAwaiting,
    siteResponse,
    initialResponse,
    min,
    max,
  };
};
